(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["velora-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('velora-reviews')) {
    customElements.define(
      'velora-reviews',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('[data-load-more]');
          this.button?.addEventListener('click', () => this.loadMore());
        }

        loadMore() {
          const step = parseInt(this.dataset.step, 10) || 4;
          const hidden = this.querySelectorAll('.velora-reviews__card--hidden');
          Array.from(hidden)
            .slice(0, step)
            .forEach((card) => card.classList.remove('velora-reviews__card--hidden'));
          if (hidden.length <= step) this.button.hidden = true;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
